import useGoBack from 'utilities/navigation/back'
import Header from 'components/headers/addLoan'
import { Field, Form, Formik } from 'formik'
import AddLoanIcon from 'assets/images/loans/add.svg'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { Schema } from './utilities'
import { toast } from 'react-toastify'
import { useState } from 'react'
import SelectModal from 'components/modals/selectModal'
import { NumericFormat } from 'react-number-format'
import { Modal } from 'react-bootstrap'
import { AiOutlineInfoCircle } from 'react-icons/ai'
import { FiChevronDown } from 'react-icons/fi'
import posthog from 'posthog-js'
import { useFundCapabilities } from 'modules/fund/capabilities'
import CustomBottomSheet from 'components/bottomSheet'

import {
    MoneyPoolCashinTypePortion,
    MoneyPoolCashinTypeCustom,
    MoneyPoolCashinTypeHibahExpense,
    MoneyPoolCashinTypeHibahCapital,
} from '../../../utilities/helper/moneyPools'
interface ISelectUser {
    name: string
    id: undefined | number
    memberId: undefined | number
}

const cashinTypeInfo: { value: string; title: string; desc: string }[] = [
    {
        value: MoneyPoolCashinTypePortion,
        title: 'پرداخت حق عضویت',
        desc: 'جزو سرمایه‌ی شخصی شما می‌شود و تعهدات ماهانه را نیز پرداخت می‌کند.',
    },
    {
        value: MoneyPoolCashinTypeCustom,
        title: 'افزایش موجودی',
        desc: 'جزو سرمایه‌ی شخصی شما می‌شود ولی اثری روی تعهدات ماهانه ندارد.',
    },
    {
        value: MoneyPoolCashinTypeHibahExpense,
        title: 'هبه برای پوشش هزینه صندوق',
        desc: 'مدیر صندوق می‌تواند برای هزینه‌های صندوق از این مبلغ استفاده کند؛ مثلاً برای پرداخت هزینه‌ی اشتراک صندوق در همیان. این مبلغ جزو سرمایه‌ی شخصی شما نمی‌شود.',
    },
    {
        value: MoneyPoolCashinTypeHibahCapital,
        title: 'هبه بلاعوض به صندوق',
        desc: 'مدیر صندوق می‌تواند از این مبلغ برای وام‌دهی استفاده کند و جزو سرمایه‌ی شخصی شما محسوب نمی‌شود.',
    },
]
export default function DepositPage() {
    const [isOpenReceiver, setIsOpenReceiver] = useState<boolean>(false)
    const [isOpenInfo, setIsOpenInfo] = useState<boolean>(false)
    const [isOpenType, setIsOpenType] = useState<boolean>(false)
    const [memberId, setMemberId] = useState<undefined | number>()
    const [trustState, setTrustState] = useState<boolean>(false)
    const navigate = useNavigate()
    const goBack = useGoBack()
    const { state } = useLocation()
    const { id } = useParams()

    // Android shows the «پرداخت کننده» picker to anyone whose role is not
    // normal (MoneypoolAddCashinActivity:72). This used to test `=== 'mgr'`
    // only, which hid it from every fund *owner* — 41,933 live funds have an
    // `own` holder against 626 with a `mgr`, so in practice the picker was
    // invisible and managers could only ever deposit for themselves.
    //
    // The picker goes with «پرداخت تنها ثبت شود» on the next screen: whoever
    // may record a cash-in for the fund — a manager, or a «بانی» the fund
    // lets record cash-ins (modules/fund/capabilities).
    const caps = useFundCapabilities(state?.moneyPoolId ?? id, state?.role)
    const isManager = caps.manage
    const canRecord = caps.record_cashin

    // Default the payer to the caller's own poolship so the flow behaves
    // exactly as before for the common case; picking someone else is opt-in.
    // Without this, `selectedUser?.id` was undefined until the manager opened
    // the modal, and the whole request went out with `poolship: undefined`.
    const profile = JSON.parse(localStorage.getItem('profile') || '{}')
    const selfPoolShipId = state?.selfPoolShipId ?? state?.poolShipId
    const [selectedUser, setSelectedUser] = useState<ISelectUser | undefined>({
        name:
            state?.selfName ||
            [profile?.first_name, profile?.last_name].filter(Boolean).join(' '),
        id: selfPoolShipId,
        memberId: profile?.id,
    })

    const payerPoolShipId = canRecord ? selectedUser?.id : selfPoolShipId
    const isPayingForOther = canRecord && payerPoolShipId !== selfPoolShipId

    return (
        <>
            <Formik
                initialValues={{
                    amount: '',
                    type: '',
                    tag: '',
                }}
                onSubmit={(values) => {
                    if (values.type.length === 0) {
                        toast.error('فیلد بابت ضروری می باشد')
                    } else if (!payerPoolShipId) {
                        toast.error('پرداخت کننده را انتخاب کنید')
                    } else {
                        posthog.capture('deposit_started', {
                            fund_id: state?.moneyPoolId,
                            deposit_type: values.type,
                            is_manager: isManager,
                            actor_role: caps.role,
                            is_for_other_member: isPayingForOther,
                        })
                        navigate('/loans/transaction', {
                            state: {
                                formikValue: values,
                                poolShipId: payerPoolShipId,
                                payerName: selectedUser?.name,
                                isPayingForOther,
                                name: state?.name,
                                moneyPoolId: state?.moneyPoolId,
                                role: state?.role,
                                canRecord,
                                trustState: state?.trustState,
                            },
                        })
                    }
                }}
                validationSchema={Schema}
            >
                {({ values, touched, errors, setFieldValue }) => (
                    <Form>
                        <div className=" mx-3 flex flex-col h-screen ">
                            <div className=" grow-0">
                                <Header title="واریز به صندوق" />
                            </div>
                            <div className=" rounded-lg grow">
                                <div className=" mt-24 bg-white rounded-lg relative pt-1 shadow-[rgba(50,50,93,0.25)_0px_6px_12px_-2px,_rgba(0,0,0,0.3)_0px_3px_7px_-3px]">
                                    <img
                                        src={AddLoanIcon}
                                        alt="add-loan"
                                        className=" absolute right-[35%] md:right-1/2 md:translate-x-1/2 -top-14"
                                    />
                                    <div className=" mt-14 w-full">
                                        <p className=" text-sm text-center text-gray-1">
                                            {' '}
                                            مبلغ واریز:
                                        </p>
                                        <NumericFormat
                                            customInput={Field}
                                            thousandSeparator
                                            placeholder="مبلغ(تومان)"
                                            allowNegative={false}
                                            name="amount"
                                            className="w-full outline-0 text-center border-b border-dashed border-gray-1 py-3"
                                            onValueChange={(values) => {
                                                const { value } = values
                                                setFieldValue('amount', value)
                                            }}
                                        />
                                        {errors.amount && touched.amount && (
                                            <p className=" text-sm text-error-3 text-center">
                                                {errors.amount}
                                            </p>
                                        )}
                                        {canRecord && (
                                            <div
                                                onClick={() =>
                                                    setIsOpenReceiver(true)
                                                }
                                                className="w-full outline-0 cursor-pointer text-center border-b border-dashed border-gray-1 py-3 bg-white"
                                            >
                                                <span className="text-gray-1 text-sm">
                                                    پرداخت کننده:{' '}
                                                </span>
                                                <span
                                                    className={
                                                        selectedUser?.name
                                                            ? 'text-gray-800'
                                                            : 'text-placeholder'
                                                    }
                                                >
                                                    {selectedUser?.name ||
                                                        'انتخاب کنید'}
                                                </span>
                                            </div>
                                        )}

                                        {/* «بابت» used to be a native <select>.
                                            Desktop Chrome draws that list in its
                                            own popup, and with this page's RTL +
                                            centred text it pushed the option
                                            labels out of the popup: members saw
                                            a grey bar and the tail of one word
                                            («...دوق») and could not tell the
                                            four kinds apart. An in-app list
                                            looks the same in every browser and
                                            messenger, and has room for what
                                            each kind actually means. */}
                                        <div className=" flex items-center w-full border-b border-dashed border-gray-1">
                                            <button
                                                type="button"
                                                onClick={() =>
                                                    setIsOpenType(true)
                                                }
                                                aria-haspopup="dialog"
                                                className=" relative grow outline-0 text-center py-3 px-6 bg-white"
                                            >
                                                <span className="text-gray-1 text-sm">
                                                    بابت:{' '}
                                                </span>
                                                <span
                                                    className={
                                                        values.type
                                                            ? 'text-gray-800'
                                                            : 'text-placeholder'
                                                    }
                                                >
                                                    {cashinTypeInfo.find(
                                                        (item) =>
                                                            item.value ===
                                                            values.type
                                                    )?.title || 'انتخاب کنید'}
                                                </span>
                                                <FiChevronDown
                                                    aria-hidden
                                                    className=" absolute left-1 top-1/2 -translate-y-1/2 text-gray-1"
                                                    size={18}
                                                />
                                            </button>
                                            <AiOutlineInfoCircle
                                                onClick={() =>
                                                    setIsOpenInfo(true)
                                                }
                                                className=" text-green-1 shrink-0 ml-2 cursor-pointer"
                                                size={22}
                                                title="راهنمای انواع واریز"
                                            />
                                        </div>
                                        <Field
                                            as="textarea"
                                            name="tag"
                                            className="w-full outline-0 text-center py-4 px-4 text-sm"
                                            placeholder="توضیحات"
                                        />
                                    </div>
                                </div>
                            </div>
                            <button
                                className=" grow-0 bg-green-1 text-white py-3 rounded-lg"
                                type="submit"
                            >
                                واریز
                            </button>
                            <button
                                type="button"
                                className=" text-center my-3 text-gray-4"
                                onClick={goBack}
                            >
                                بعدا
                            </button>
                        </div>
                        <CustomBottomSheet
                            isOpen={isOpenType}
                            onDismiss={() => setIsOpenType(false)}
                            dragHandleOnly
                        >
                            <p className=" mb-2 text-center text-sm font-bold text-heading">
                                بابت این واریز را انتخاب کنید
                            </p>
                            <div
                                role="radiogroup"
                                aria-label="بابت"
                                className=" max-h-[70vh] overflow-y-auto"
                            >
                                {cashinTypeInfo.map((item) => {
                                    const picked = values.type === item.value
                                    return (
                                        <button
                                            key={item.value}
                                            type="button"
                                            role="radio"
                                            aria-checked={picked}
                                            onClick={() => {
                                                setFieldValue(
                                                    'type',
                                                    item.value
                                                )
                                                setIsOpenType(false)
                                            }}
                                            className=" flex w-full items-center justify-between gap-3 border-b border-divider py-3 text-right last:border-b-0"
                                        >
                                            <span>
                                                <span
                                                    className={` block text-sm ${
                                                        picked
                                                            ? 'font-bold text-green-1'
                                                            : 'text-text-body'
                                                    }`}
                                                >
                                                    {item.title}
                                                </span>
                                                <span className=" mt-1 block text-xs leading-6 text-gray-1">
                                                    {item.desc}
                                                </span>
                                            </span>
                                            <span
                                                aria-hidden
                                                className={` h-4 w-4 shrink-0 rounded-full border-2 ${
                                                    picked
                                                        ? ' border-green-1 bg-green-1'
                                                        : ' border-stroke'
                                                }`}
                                            />
                                        </button>
                                    )
                                })}
                            </div>
                        </CustomBottomSheet>
                    </Form>
                )}
            </Formik>
            <SelectModal
                show={isOpenReceiver}
                onHide={() => setIsOpenReceiver(false)}
                setSelectedUser={setSelectedUser}
                setMemberId={setMemberId}
                title="پرداخت کننده را انتخاب کنید"
            />
            <Modal
                show={isOpenInfo}
                onHide={() => setIsOpenInfo(false)}
                centered
            >
                <div className=" py-4 px-4">
                    <p className=" text-center text-sm text-green-1 mb-3">
                        راهنمای انواع واریز
                    </p>
                    {cashinTypeInfo.map((item) => (
                        <div key={item.title} className=" mb-3">
                            <p className=" text-sm font-bold text-gray-800">
                                {item.title}
                            </p>
                            <p className=" text-xs text-gray-1 leading-6">
                                {item.desc}
                            </p>
                        </div>
                    ))}
                    <button
                        type="button"
                        className=" w-full bg-green-1 text-white py-2 rounded-lg mt-2"
                        onClick={() => setIsOpenInfo(false)}
                    >
                        متوجه شدم
                    </button>
                </div>
            </Modal>
        </>
    )
}
